import { Component, Mixins } from 'vue-property-decorator';
import CalendarCard from '../card';
import CalendarText, { Variants } from '../text';
import Props from './props';
import { DONE_TEXT } from './const';

@Component({
  components: {
    CalendarCard,
    CalendarText,
  }
})
export default class CalendarDetail extends Mixins(Props) {
  // Computed
  get variant() {
    const { NOTHING, WAITING, DONE } = Variants;
    const { count, completed } = this;
    if (count === 0) return NOTHING;
    if (completed) return DONE;
    return WAITING;
  }

  get textOfCoplete() {
    const { completed, text } = this;
    return completed ? DONE_TEXT : text;
  }
}



// WEBPACK FOOTER //
// ./src/components/calendar/detail/script.ts